import moment from "moment";
import { expiryStatus } from "../common/ExpiryStatus";
import { getSubscriptionString } from "../common/ConvertSubscription";

export const getResellerList = async (dynamoDBClient) => {
  try {
    const params = {
      TableName: "Resellers",
      ProjectionExpression: "ResellerID,GatewayMAC,BeaconMAC,DateCreated",
    };
    const params2 = {
      TableName: "GatewayData",
      ProjectionExpression: "GatewayMAC",
    };
    const params3 = {
      TableName: "BeaconData",
      ProjectionExpression: "BeaconMAC",
    };
    const params4 = {
      TableName: "GatewayUser",
      ProjectionExpression: "Email,GatewayMAC",
    };

    const params6 = {
      TableName: "DeviceToken",
      ProjectionExpression: "Email,MobileDevice",
    };
    const params7 = {
      TableName: "Beacons",
      ProjectionExpression: "Email,BeaconMAC",
    };
    const params8 = {
      TableName: "SubscriptionUser",
      ProjectionExpression: "SubscriptionState,Email",
    };
    const params9 = {
      TableName: "SubscriptionUserIOS",
      ProjectionExpression: "NotificationType,Email",
    };

    const data = await dynamoDBClient.scan(params).promise();
    const data2 = await dynamoDBClient.scan(params2).promise();
    const data3 = await dynamoDBClient.scan(params3).promise();
    const data4 = await dynamoDBClient.scan(params4).promise();
    const data6 = await dynamoDBClient.scan(params6).promise();
    const data7 = await dynamoDBClient.scan(params7).promise();
    const data8 = await dynamoDBClient.scan(params8).promise();
    const data9 = await dynamoDBClient.scan(params9).promise();
    return {
      resellerTable: data,
      gatewayTable: data2,
      beaconTable: data3,
      gatewayUser: data4,
      deviceToken: data6,
      beacons: data7,
      android: data8,
      ios: data9,
    };
  } catch (error) {
    throw new Error();
  }
};

export const getResellerBaseStationStatus = async (
  dynamoDBClient,
  reseller
) => {
  try {
    const baseStationList = [];
    const params = {
      TableName: "Resellers",
      FilterExpression: "ResellerID = :id",
      ExpressionAttributeValues: {
        ":id": reseller,
      },
      ProjectionExpression: "GatewayMAC",
    };

    const param2 = {
      TableName: "GatewayData",
      ProjectionExpression: "GatewayMAC,DateUpdated",
    };
    const data = await dynamoDBClient.scan(params).promise();
    const data2 = await dynamoDBClient.scan(param2).promise();
    const result1 = data.Items;
    const result2 = data2.Items;

    let check = false;

    await Promise.all(
      result1.map((item) => {
        const foundGateway = result2.filter(
          (gateway) => gateway.GatewayMAC === item.GatewayMAC
        );
        if (foundGateway.length > 0) {
          check = true;
          baseStationList.push({
            id: item.GatewayMAC,
            status: "Active",
            email: "",
            activationTime: "",
            subStatus: "",
            subType: "",
            plan: "",
          });
        } else {
          if (item.GatewayMAC !== "") {
            baseStationList.push({
              id: item.GatewayMAC,
              status: "InActive",
              email: "",
              activationTime: "",
              subStatus: "",
              subType: "",
              plan: "",
            });
          }
        }
      })
    );
    return { baseStationList, check };
  } catch (error) {
    throw new Error();
  }
};

export const getResellerBaseStationStatus2 = async (dynamoDBClient, arr) => {
  // This function gets email of active gateway
  try {
    let check = false;
    const params = {
      RequestItems: {
        GatewayUser: {
          Keys: [],
          ProjectionExpression: "Email,GatewayMAC",
        },
      },
    };

    await Promise.all(
      arr.map(async (element) => {
        if (element.status === "Active") {
          params.RequestItems.GatewayUser.Keys.push({
            GatewayMAC: element.id,
          });
        }
      })
    );

    const data = await dynamoDBClient.batchGet(params).promise();

    const response = data.Responses.GatewayUser;

    await Promise.all(
      arr.map(async (element) => {
        if (element.status === "Active") {
          check = true;
          const foundGateway = response.filter(
            (item) => item.GatewayMAC === element.id
          );

          if (foundGateway.length > 0) {
            element.email = foundGateway[0].Email;
          } else {
            element.status = "InActive";
          }
        }
      })
    );

    return { arr, check };
  } catch (error) {
    throw new Error();
  }
};

export const getResellerBaseStationStatus3 = async (dynamoDBClient, arr) => {
  // this function gets activation date for active gateway
  try {
    const params = {
      RequestItems: {
        Gateways: {
          Keys: [],
          ProjectionExpression: "DateCreated,GatewayMAC",
        },
      },
    };
    await Promise.all(
      arr.map(async (element) => {
        if (element.status === "Active") {
          params.RequestItems.Gateways.Keys.push({
            Email: element.email,
            GatewayMAC: element.id,
          });
        }
      })
    );

    const data = await dynamoDBClient.batchGet(params).promise();

    const response = data.Responses.Gateways;

    await Promise.all(
      arr.map(async (element) => {
        if (element.status === "Active") {
          const foundGateway = response.filter(
            (item) => item.GatewayMAC === element.id
          );

          if (foundGateway.length > 0) {
            element.activationTime = moment
              .utc(foundGateway[0].DateCreated)
              .local()
              .format("YYYY-MM-DD h:mm:ss A");
          }
        }
      })
    );

    return arr;
  } catch (error) {
    throw new Error();
  }
};

export const getSubscriptionsStatus = async (dynamoDBClient, arr) => {
  // this function will read the device token table to get which subscription to read

  try {
    const params = {
      RequestItems: {
        DeviceToken: {
          Keys: [],
          ProjectionExpression: "Email,MobileDevice",
        },
      },
    };
    const params2 = {
      RequestItems: {
        Users: {
          Keys: [],
          ProjectionExpression: "Email,DateSubmitted",
        },
      },
    };

    await Promise.all(
      arr.map(async (element) => {
        if (element.status === "Active") {
          const check = params.RequestItems.DeviceToken.Keys.filter(
            (item) => item.Email === element.email
          );
          if (check.length === 0) {
            params.RequestItems.DeviceToken.Keys.push({
              Email: element.email,
            });
          }
          const check2 = params2.RequestItems.Users.Keys.filter(
            (item) => item.Email === element.email
          );
          if (check2.length === 0) {
            params2.RequestItems.Users.Keys.push({
              Email: element.email,
              RoleId: "3",
            });
          }
        }
      })
    );

    const data = await dynamoDBClient.batchGet(params).promise();

    const data2 = await dynamoDBClient.batchGet(params2).promise();

    const response = data.Responses.DeviceToken;
    const accountresponse = data2.Responses.Users;

    await Promise.all(
      arr.map(async (element) => {
        if (element.status === "Active") {
          const foundUserAccount = accountresponse.filter(
            (item) => item.Email === element.email
          );

          element.accountCreationDate = foundUserAccount[0].DateSubmitted;
          const foundUserToken = response.filter(
            (item) => item.Email === element.email
          );

          if (foundUserToken.length > 0) {
            if (foundUserToken[0].MobileDevice === "Android") {
              const params2 = {
                TableName: "SubscriptionUser",
                KeyConditionExpression: "Email = :email",
                ExpressionAttributeValues: {
                  ":email": element.email,
                },
                ProjectionExpression:
                  "SubscriptionState,SubscriptionPlanType,SubscriptionId,StartTime,ExpiryTime,PromoCode",
              };
              const data2 = await dynamoDBClient.query(params2).promise();

              const result = data2.Items[0];
              element.subStatus = result?.SubscriptionState;
              if (expiryStatus.includes(element.subStatus)) {
                element.status = "InActive";
              }
              element.subType = result?.SubscriptionPlanType;
              element.subId = result?.SubscriptionId;
              element.subscriptionStart = result?.StartTime;
              element.subscriptionEnd = result?.ExpiryTime;
              element.promoCode = result?.PromoCode;

              if (element.subType === "P1M") {
                element.plan = `${getSubscriptionString(
                  element.subId
                )} Monthly`;
              } else {
                element.plan = `${getSubscriptionString(element.subId)} Yearly`;
              }
              //   if (element.subId === "notice_service") {
              //     if (element.subType === "P1M") {
              //       element.plan = "Standard Notification Monthly";
              //     } else {
              //       element.plan = "Standard Notification Yearly";
              //     }
              //   } else {
              //     if (element.subType === "P1M") {
              //       element.plan = "Group Notification Monthly";
              //     } else {
              //       element.plan = "Group Notification Yearly";
              //     }
              //   }
            } else {
              const params2 = {
                TableName: "SubscriptionUserIOS",
                KeyConditionExpression: "Email = :email",
                ExpressionAttributeValues: {
                  ":email": element.email,
                },
                ProjectionExpression:
                  "ProductId,NotificationType,ExpiresDate,PromoCode,PurchaseDate",
              };
              const data2 = await dynamoDBClient.query(params2).promise();

              const result = data2.Items[0];
              element.subStatus = result?.NotificationType;
              element.subscriptionStart = result?.PurchaseDate;
              element.subscriptionEnd = result?.ExpiresDate;
              element.promoCode = result?.PromoCode;
              if (expiryStatus.includes(element.subStatus)) {
                element.status = "InActive";
              }

              if (result?.ProductId.includes("monthly")) {
                element.plan = `${getSubscriptionString(
                  result?.ProductId
                )} Monthly`;
              }
              if (result?.ProductId.includes("yearly")) {
                element.plan = `${getSubscriptionString(
                  result?.ProductId
                )} Yearly`;
              }
              //   if (result?.ProductId === "notice_service_monthly") {
              //     element.plan = "Standard Notification Monthly";
              //   }
              //   if (result?.ProductId === "notice_service_yearly") {
              //     element.plan = "Standard Notification Yearly";
              //   }
              //   if (result?.ProductId === "group_notice_service_yearly") {
              //     element.plan = "Group Notification Yearly";
              //   }
              //   if (result?.ProductId === "group_notice_service_monthly") {
              //     element.plan = "Group Notification Monthly";
              //   }

              element.subType = result?.ProductId;
            }
          }
        }
      })
    );

    return arr;
  } catch (error) {
    throw new Error();
  }
};

export const getResellerBeaconStatus = async (dynamoDBClient, reseller) => {
  try {
    const beaconList = [];
    const params = {
      TableName: "Resellers",
      FilterExpression: "ResellerID = :id",
      ExpressionAttributeValues: {
        ":id": reseller,
      },
      ProjectionExpression: "BeaconMAC",
    };

    const param2 = {
      TableName: "BeaconData",
      ProjectionExpression: "BeaconMAC,DateUpdated,Email",
    };
    const data = await dynamoDBClient.scan(params).promise();
    const data2 = await dynamoDBClient.scan(param2).promise();
    const result1 = data.Items;
    const result2 = data2.Items;
    let check = false;

    await Promise.all(
      result1.map((item) => {
        const foundBeacon = result2.filter(
          (beacon) => beacon.BeaconMAC === item.BeaconMAC
        );
        if (foundBeacon.length > 0) {
          check = true;
          beaconList.push({
            id: item.BeaconMAC,
            status: "Active",
            email: "",
            activationTime: "",
            subStatus: "",
            subType: "",
            plan: "",
          });
        } else {
          if (item.BeaconMAC !== "") {
            beaconList.push({
              id: item.BeaconMAC,
              status: "InActive",
              email: "",
              activationTime: "",
              subStatus: "",
              subType: "",
              plan: "",
            });
          }
        }
      })
    );
    return { beaconList, check };
  } catch (error) {
    throw new Error();
  }
};

export const getResellerBeaconStatus2 = async (dynamoDBClient, arr) => {
  // This function gets email of active beacons
  try {
    let check = false;

    await Promise.all(
      arr.map(async (element) => {
        if (element.status === "Active") {
          const params = {
            TableName: "Beacons",
            FilterExpression: "BeaconMAC = :mac",
            ExpressionAttributeValues: {
              ":mac": element.id,
            },
            ProjectionExpression: "Email,DateCreated",
          };

          const response = await dynamoDBClient.scan(params).promise();
          if (response.Items.length > 0) {
            check = true;
            const data = response.Items[0];
            element.email = data.Email;
            element.activationTime = moment
              .utc(data.DateCreated)
              .local()
              .format("YYYY-MM-DD h:mm:ss A");
          } else {
            element.status = "InActive";
          }
        }
      })
    );

    return { arr, check };
  } catch (error) {
    throw new Error();
  }
};

export const getResellerBaseStation = async (dynamoDBClient, reseller) => {
  try {
    const params = {
      TableName: "Resellers",
      FilterExpression: "ResellerID = :id",
      ExpressionAttributeValues: {
        ":id": reseller,
      },
      ProjectionExpression: "GatewayMAC, Id, ResellerID",
    };

    const data = await dynamoDBClient.scan(params).promise();
    const result1 = data.Items;

    const baseStationList = result1.filter((item) => item.GatewayMAC !== "");
    return baseStationList;
  } catch (error) {
    throw new Error();
  }
};

export const getResellerBeacon = async (dynamoDBClient, reseller) => {
  try {
    const params = {
      TableName: "Resellers",
      FilterExpression: "ResellerID = :id",
      ExpressionAttributeValues: {
        ":id": reseller,
      },
      ProjectionExpression: "BeaconMAC, Id,ResellerID",
    };

    const data = await dynamoDBClient.scan(params).promise();
    const result1 = data.Items;

    const beaconList = result1.filter((item) => item.BeaconMAC !== "");

    return beaconList;
  } catch (error) {
    throw new Error();
  }
};
